if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.bindThumbnailEvents();
        
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }
      
      bindThumbnailEvents() {
        if (!this.elements.thumbnails) return;
        
        // Observer pour rebinder les événements quand les thumbnails changent
        const observer = new MutationObserver(() => {
          this.rebindThumbnailEvents();
        });
        
        observer.observe(this.elements.thumbnails, {
          childList: true,
          subtree: true,
          attributes: true,
          attributeFilter: ['style']
        });
        
        this.rebindThumbnailEvents();
      }
      
      rebindThumbnailEvents() {
        if (!this.elements.thumbnails) return;
        
        // Seulement binder les thumbnails visibles
        const visibleThumbnails = this.elements.thumbnails.querySelectorAll('.thumbnail-list__item:not([style*="display: none"]) button');
        
        visibleThumbnails.forEach((button) => {
          const mediaToSwitch = button.closest('[data-target]');
          if (mediaToSwitch) {
            // Supprimer l'ancien listener s'il existe
            button.replaceWith(button.cloneNode(true));
            const newButton = mediaToSwitch.querySelector('button');
            newButton.addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
          }
        });
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId, prepend) {
        // Chercher dans tous les éléments visibles
        const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('.product__media-item:not([style*="display: none"])');
        
        if (!activeMedia) {
          return;
        }
        
        // Désactiver tous les médias visibles
        this.elements.viewer.querySelectorAll('.product__media-item:not([style*="display: none"])').forEach((element) => {
          element.classList.remove('is-active');
        });
        
        activeMedia.classList.add('is-active');

        if (prepend) {
          // Pas besoin de prepend avec cette structure, juste s'assurer que l'élément est visible
          if (activeMedia.style.display === 'none') {
            activeMedia.style.display = 'block';
          }

          if (this.elements.viewer.slider) this.elements.viewer.resetPages();
        }

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail?.dataset?.mediaPosition || '1');
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        // Désactiver tous les thumbnails visibles
        this.elements.thumbnails.querySelectorAll('.thumbnail-list__item:not([style*="display: none"]) button').forEach((element) => {
          element.removeAttribute('aria-current');
        });
        
        const button = thumbnail.querySelector('button');
        if (button) {
          button.setAttribute('aria-current', true);
        }
        
        if (this.elements.thumbnails.isSlideVisible && this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        if (this.elements.thumbnails.slider) {
          this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
        }
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img, img');
        if (!image) return;
        
        const announceImage = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          const message = window.accessibilityStrings?.imageAvailable 
            ? window.accessibilityStrings.imageAvailable.replace('[index]', position)
            : `Image ${position} disponible`;
          this.elements.liveRegion.innerHTML = message;
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 2000);
        };
        
        if (image.complete) {
          announceImage();
        } else {
          image.onload = announceImage;
          setTimeout(announceImage, 1000);
        }
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems?.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}